import { useQuery } from '@tanstack/react-query';
import { getShareConfig } from '@/api/subtitles';

// ShareConfigResp 在 types.d.ts 的 ambient `declare namespace API` 里,
// 全局可用,不需要显式 import。

export interface UseShareConfigResult {
  desktopLangs: string[];
  maxExtraLangs: number | null;
  audienceLangs: string[];
  isLoading: boolean;
  refetch: () => void;
}

export function useShareConfig(roomId?: string): UseShareConfigResult {
  const { data, isLoading, refetch } = useQuery<API.ShareConfigResp>({
    queryKey: ['shareConfig', roomId],
    queryFn: async () => {
      const res = await getShareConfig({ roomId: roomId! });
      // res 是 axios response, 实际数据在 res.data.data
      return res.data.data;
    },
    enabled: !!roomId,
    // 5 秒一次 —— 让桌面端段控切换 (max_extra_langs) / 主播改 desktop_langs
    // 在观众侧能近实时同步(配合桌面端的 useShareMultiplier 也是 5 秒一致)
    refetchInterval: 5_000,
    staleTime: 2_000,
  });

  return {
    // 内部用 camelCase 返回(hook 是给 React 组件用的,组件侧约定 camelCase)
    desktopLangs: data?.desktop_langs ?? [],
    maxExtraLangs: data?.max_extra_langs ?? null,
    audienceLangs: data?.audience_langs ?? [],
    isLoading,
    refetch,
  };
}
